module.exports = __webpack_public_path__ + "img/图片.76aff3c5.svg";